// 消息中心
export default [
  {
    path: '/info',
    name: 'info',
    component: () => import ('@/components/page/info/info')
  },
  {
    path: '/infoDetail',
    name: 'infoDetail',
    component: () => import ('@/components/page/info/infoDetail')
  },
  {
    path: '/pushMessage',
    name: 'pushMessage',
    component: () => import ('@/components/page/info/pushMessage/pushMessage')
  },
  {
    path: '/pushMessageList',
    name: 'pushMessageList',
    component: () => import ('@/components/page/info/pushMessage/pushMessageList')
  },
  {
    path: '/pushMessageDetail',
    name: 'pushMessageDetail',
    component: () => import ('@/components/page/info/pushMessage/pushMessageDetail')
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/info.js